import { Serializable } from '@adaptiva/core/common';
import { ELlmResponseType } from '../enums';
import { ILlmConversationNode, ILlmPayload } from '../interfaces';

type LlmConversationNodeInit<P extends ILlmPayload = ILlmPayload> = Partial<LlmConversationNode<P> | ILlmConversationNode<P>>;

export class LlmConversationNode<P extends ILlmPayload = ILlmPayload> extends Serializable implements ILlmConversationNode {

	protected static override excludedProperties: string[] = ['parent'];

	public nodeId: string;

	public userMessage: string;

	public llmResponse: string;

	public responseType: ELlmResponseType;

	public forkName: string;

	public userMessageSentTimestamp: long;

	public llmResponseReceivedTimestamp: long;

	public children: LlmConversationNode<ILlmPayload>[];

	public payload: P;

	public suggestedPrompts: string[];

	public parent?: LlmConversationNode;

	constructor(_node?: LlmConversationNodeInit<P>) {
		super();

		this.nodeId = _node?.nodeId || '';
		this.userMessage = _node?.userMessage || '';
		this.llmResponse = _node?.llmResponse || '';
		this.responseType = _node?.responseType || ELlmResponseType.TEXT;
		this.forkName = _node?.forkName || null;
		this.userMessageSentTimestamp = _node?.userMessageSentTimestamp ?? Date.now();
		this.llmResponseReceivedTimestamp = _node?.llmResponseReceivedTimestamp ?? Date.now();
		this.payload = _node?.payload;
		this.suggestedPrompts = _node?.suggestedPrompts ?? [];
		this.parent = (_node as Partial<LlmConversationNode<P>>)?.parent;
		this.children = _node?.children?.map((_child: LlmConversationNode) => new LlmConversationNode({
			..._child,
			parent: this,
		}));
	}

}
